// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1L3fk","alert":"SettungsInbox_alert__PObiS"};